import { render } from "./PublicationAiUploadSources.vue?vue&type=template&id=eec865c4"
import script from "./PublicationAiUploadSources.vue?vue&type=script&lang=js"
export * from "./PublicationAiUploadSources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__